import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from 'react-intl'
import FooterContainer from '@/scopes/common/components/Footer/FooterContainer'
import { shouldShowFooterLegalDisclaimer } from '@/scopes/common/domain/policies/siteName'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'

export function CheckoutFooter() {
  const intl = useIntl()
  const siteName = useConfiguration('siteName')

  const legalDisclaimer = shouldShowFooterLegalDisclaimer(siteName) && (
    <div>
      <Typography variant="body-m-regular-tight">
        {intl.formatMessage({ id: 'footer_legal_disclaimer' })}
      </Typography>
    </div>
  )

  if (!legalDisclaimer) {
    return null
  }

  return (
    <FooterContainer transparentBackground>
      {legalDisclaimer}
    </FooterContainer>
  )
}
